/* Triumph DATA PLATE | tl-header.js
   Behaviour of sections/header.liquid (port of the Wix site-header init script, sections/header.py JS).

   Mega panels  disclosure buttons (aria-expanded/aria-controls). Click, Enter or Space toggles; a mouse
                hover opens after a short intent delay and closes ~160ms after the pointer leaves; Esc
                closes and returns focus; an outside click, a link click or tabbing out closes; one open.
   Drawer       < 1080px: burger opens a dialog from the right (TL.trapFocus, Esc, backdrop, TL.lockScroll);
                closes when the viewport grows past 1080px or a link inside is followed.
   Current page a[data-nav] whose path equals the page path gets aria-current="page"; the mega menu
                that contains it is marked .is-cur (unless a top-level link is current).
   Search       trims the query; with settings.predictive_search the field becomes a combobox fed by
                sections/predictive-search.liquid (Section Rendering API): arrows / Enter / Esc,
                aria-activedescendant, debounced, cached, stale responses dropped. No JS: plain form.
   Cart         'tl:cart:updated' updates the cart link's aria-label (the count itself is painted by
                tl-global.js on [data-tl-cart-count]); 'tl:cart:added' {item, cart} opens the
                notification popover (settings.cart_type = notification): item photo, brand, title,
                variant, price, View cart (N), Check out. Focus moves to it; Esc, the close buttons or an
                outside click close it and focus returns to where it was.
   Account      <shopify-account> 'open' event: anchors its sheet under the button (as Dawn does).
   Theme editor re-initialised on shopify:section:load, torn down on shopify:section:unload.
   Vanilla ES2017, depends only on window.TL from tl-global.js (with fallbacks). */
(function () {
  'use strict';

  var TL = window.TL = window.TL || {};
  var SEL = '[data-tl-header]';

  function norm(p) {
    return String(p || '').split(/[?#]/)[0].toLowerCase().replace(/\/+$/, '') || '/';
  }
  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }
  function setExpanded(el, v) {
    if (el) el.setAttribute('aria-expanded', v ? 'true' : 'false');
  }
  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function debounce(fn, ms) {
    if (typeof TL.debounce === 'function') return TL.debounce(fn, ms);
    var t;
    return function () {
      var a = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, a); }, ms);
    };
  }
  function moneyText(cents) {
    if (typeof TL.formatMoneyText === 'function') return TL.formatMoneyText(cents);
    if (typeof TL.formatMoney === 'function') {
      var d = document.createElement('div');
      d.innerHTML = TL.formatMoney(cents);
      return d.textContent;
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }
  function sizedImage(src, width) {
    if (!src) return '';
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return src;
    }
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ── one header instance ─────────────────────────────────────────────── */
  function init(hd) {
    var offs = [];
    function on(target, type, fn, opts) {
      if (!target) return;
      target.addEventListener(type, fn, opts);
      offs.push(function () { target.removeEventListener(type, fn, opts); });
    }
    function Q(s) { return hd.querySelector(s); }
    var state = { drawer: false, note: false };
    function raise() {
      hd.classList.toggle('is-raised', state.drawer || state.note);
    }

    /* mega panels */
    var items = hd.querySelectorAll('.tl-hd__mi');
    var cur = null, how = '', hov = null, tm = 0;
    function btnOf(li) { return li.querySelector('.tl-hd__mb'); }
    function setP(li, src) {
      clearTimeout(tm);
      each(items, function (x) {
        x.classList.toggle('is-open', x === li);
        setExpanded(btnOf(x), x === li);
      });
      cur = li || null;
      how = li ? src : '';
    }
    function sched() {
      clearTimeout(tm);
      tm = setTimeout(function () {
        if (hov) {
          if (cur !== hov) setP(hov, 'hover');
        } else if (cur && how === 'hover' && !cur.contains(document.activeElement)) {
          setP();
        }
      }, hov ? (cur ? 140 : 90) : 160);
    }
    each(items, function (li) {
      on(btnOf(li), 'click', function () {
        setP(cur === li && how !== 'hover' ? null : li, 'click');
      });
      on(li, 'pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        hov = li;
        if (cur === li) clearTimeout(tm); else sched();
      });
      on(li, 'pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        if (hov === li) hov = null;
        sched();
      });
      on(li, 'focusout', function (e) {
        var t = e.relatedTarget;
        if (cur === li && t && !li.contains(t)) setP();
      });
    });
    on(document, 'click', function (e) {
      if (!cur) return;
      var t = e.target;
      if (!cur.contains(t) || (t.closest && t.closest('a[href]'))) setP();
    });
    on(document, 'keydown', function (e) {
      if (!cur || e.key !== 'Escape') return;
      var li = cur, inside = li.contains(document.activeElement);
      setP();
      if (inside) {
        e.preventDefault();
        focusEl(btnOf(li));
      }
    });

    /* drawer */
    var burger = Q('.tl-hd__burger'), dw = Q('.tl-hd__dw'), panel = Q('.tl-hd__dp'), closeBtn = Q('.tl-hd__x'), body = Q('.tl-hd__db');
    function openDw() {
      if (state.drawer || !dw) return;
      state.drawer = true;
      setP();
      dw.hidden = false;
      setExpanded(burger, true);
      raise();
      if (typeof TL.lockScroll === 'function') TL.lockScroll(true);
      void panel.offsetWidth;
      dw.classList.add('is-in');
      if (body) body.scrollTop = 0;
      if (typeof TL.trapFocus === 'function') TL.trapFocus(panel, closeBtn); else focusEl(closeBtn);
    }
    function closeDw(back) {
      if (!state.drawer) return;
      state.drawer = false;
      dw.classList.remove('is-in');
      dw.hidden = true;
      setExpanded(burger, false);
      raise();
      if (typeof TL.lockScroll === 'function') TL.lockScroll(false);
      if (typeof TL.removeTrapFocus === 'function') TL.removeTrapFocus(back ? burger : null);
      else if (back) focusEl(burger);
    }
    on(burger, 'click', function () { if (state.drawer) closeDw(true); else openDw(); });
    on(closeBtn, 'click', function () { closeDw(true); });
    on(Q('.tl-hd__bd'), 'click', function () { closeDw(true); });
    on(document, 'keydown', function (e) {
      if (state.drawer && e.key === 'Escape') {
        e.preventDefault();
        closeDw(true);
      }
    });
    on(panel, 'click', function (e) {
      if (e.target.closest && e.target.closest('a[href]')) closeDw(false);
    });
    var mq = window.matchMedia ? window.matchMedia('(min-width:1080px)') : null;
    function onMq() {
      if (mq.matches) closeDw(false); else setP();
    }
    if (mq) {
      if (mq.addEventListener) {
        mq.addEventListener('change', onMq);
        offs.push(function () { mq.removeEventListener('change', onMq); });
      } else if (mq.addListener) {
        mq.addListener(onMq);
        offs.push(function () { mq.removeListener(onMq); });
      }
    }
    function shut() {
      closeDw(false);
      setP();
    }
    on(window, 'hashchange', shut);

    /* current page */
    var here = norm(window.location.pathname);
    each(hd.querySelectorAll('a[data-nav]'), function (a) {
      var h = a.getAttribute('href') || '';
      if (h.indexOf('#') < 0 && norm(h) === here) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
    var topCur = Q('.tl-hd__nk[aria-current]');
    each(items, function (x) {
      x.classList.toggle('is-cur', !topCur && !!x.querySelector('[aria-current]'));
    });

    /* search */
    var form = Q('.tl-hd__search'), input = Q('.tl-hd__q');
    var ps = null;
    if (form && input) {
      on(form, 'submit', function (e) {
        if (e.defaultPrevented) return;
        var v = input.value.trim();
        input.value = v;
        if (!v) {
          e.preventDefault();
          focusEl(input);
        }
      });
      if (form.hasAttribute('data-tl-ps') && TL.settings && TL.settings.predictiveSearch !== false &&
          typeof window.fetch === 'function' && typeof window.DOMParser === 'function') {
        ps = predictive(form, input, on);
      }
    }

    /* cart link label */
    var cartLink = Q('.tl-hd__cart');
    on(document, 'tl:cart:updated', function (e) {
      var cart = e.detail && e.detail.cart;
      if (!cart || !cartLink) return;
      var n = parseInt(cart.item_count, 10) || 0;
      var tpl = cartLink.getAttribute(n === 1 ? 'data-label-one' : 'data-label-other');
      if (tpl) cartLink.setAttribute('aria-label', tpl.replace('{count}', String(n)));
    });

    /* add-to-cart notification */
    var note = Q('[data-tl-note]');
    if (note) notification(hd, note, state, raise, on);

    /* <shopify-account>: anchor its sheet under the button (the open event is composed, not bubbling) */
    on(document, 'open', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('shopify-account') || !hd.contains(t)) return;
      var bottom = Math.max(0, Math.round(t.getBoundingClientRect().bottom));
      t.style.setProperty('--tl-acc-top', bottom + 'px');
    }, true);

    return {
      destroy: function () {
        if (state.drawer) closeDw(false);
        if (state.note && note) note.hidden = true;
        state.note = false;
        clearTimeout(tm);
        if (ps) ps.destroy();
        offs.forEach(function (off) { off(); });
        offs = [];
        hd.classList.remove('is-raised');
      }
    };
  }

  /* ── predictive search combobox ──────────────────────────────────────── */
  function predictive(form, input, on) {
    var panel = form.querySelector('[data-tl-ps-panel]');
    if (!panel) return null;
    var base = (TL.routes && TL.routes.predictive_search) || '/search/suggest';
    var cache = {}, ctrl = null, reqId = 0, open = false, idx = -1, shownQ = '';

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', panel.id);

    function options() {
      return Array.prototype.filter.call(panel.querySelectorAll('[role="option"]'), function (o) {
        return o.getAttribute('aria-disabled') !== 'true';
      });
    }
    function setActive(i) {
      var list = options();
      each(list, function (o) {
        o.classList.remove('is-active');
        o.setAttribute('aria-selected', 'false');
      });
      if (!list.length || i < 0) {
        idx = -1;
        input.removeAttribute('aria-activedescendant');
        return;
      }
      idx = (i + list.length) % list.length;
      var o = list[idx];
      o.classList.add('is-active');
      o.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', o.id);
      if (o.scrollIntoView) o.scrollIntoView({ block: 'nearest' });
    }
    function show() {
      if (!panel.firstElementChild) return;
      panel.hidden = false;
      open = true;
      input.setAttribute('aria-expanded', 'true');
    }
    function hide() {
      if (!open && panel.hidden) return;
      setActive(-1);
      panel.hidden = true;
      open = false;
      input.setAttribute('aria-expanded', 'false');
    }
    function render(html, q) {
      panel.innerHTML = html;
      shownQ = q;
      idx = -1;
      input.removeAttribute('aria-activedescendant');
      if (!html.trim()) { hide(); return; }
      show();
      if (typeof TL.announce === 'function') {
        var n = Math.max(0, options().length - 1);
        TL.announce(n ? n + (n === 1 ? ' suggestion' : ' suggestions') + ' for ' + q : 'No suggestions for ' + q);
      }
    }
    function load(q) {
      if (Object.prototype.hasOwnProperty.call(cache, q)) {
        render(cache[q], q);
        return;
      }
      if (ctrl) ctrl.abort();
      ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var params = new URLSearchParams();
      params.set('q', q);
      params.set('section_id', 'predictive-search');
      params.set('resources[type]', 'product,collection,page,query');
      params.set('resources[limit]', '6');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');
      var mine = ++reqId;
      form.setAttribute('aria-busy', 'true');
      fetch(base + (base.indexOf('?') < 0 ? '?' : '&') + params.toString(), {
        signal: ctrl ? ctrl.signal : undefined,
        headers: { Accept: 'text/html' },
        credentials: 'same-origin'
      }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      }).then(function (text) {
        if (mine !== reqId) return;
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var res = doc.querySelector('[data-tl-ps-results]');
        var html = res ? res.innerHTML : '';
        cache[q] = html;
        if (input.value.trim() === q && document.activeElement === input) render(html, q);
      }).catch(function (err) {
        if (!err || err.name !== 'AbortError') hide();
      }).then(function () {
        if (mine === reqId) form.removeAttribute('aria-busy');
      });
    }
    var run = debounce(function () {
      var q = input.value.trim();
      if (q) load(q);
    }, 220);

    on(input, 'input', function () {
      var q = input.value.trim();
      if (!q) {
        reqId++;
        if (ctrl) ctrl.abort();
        form.removeAttribute('aria-busy');
        hide();
        panel.innerHTML = '';
        shownQ = '';
        return;
      }
      run();
    });
    on(input, 'focus', function () {
      var q = input.value.trim();
      if (q && q === shownQ && panel.firstElementChild) show();
    });
    on(input, 'keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown' || k === 'ArrowUp') {
        e.preventDefault();
        if (!open) {
          var q = input.value.trim();
          if (q && q === shownQ && panel.firstElementChild) show();
          else if (q) load(q);
          return;
        }
        /* down wraps from the last option to the first; up from the first returns to the text, up from
           the text goes to the last option */
        if (k === 'ArrowDown') setActive(idx + 1);
        else setActive(idx < 0 ? options().length - 1 : idx - 1);
      } else if (k === 'Enter') {
        if (open && idx >= 0) {
          var o = options()[idx];
          var a = o && (o.querySelector('a[href]') || (o.matches('a[href]') ? o : null));
          if (a) {
            e.preventDefault();
            a.click();
          }
        }
      } else if (k === 'Escape') {
        if (open) {
          e.preventDefault();
          e.stopPropagation();
          hide();
        }
      } else if (k === 'Tab') {
        hide();
      }
    });
    /* keep focus in the field while the pointer picks a result */
    on(panel, 'mousedown', function (e) { e.preventDefault(); });
    on(panel, 'mousemove', function (e) {
      var o = e.target.closest && e.target.closest('[role="option"]');
      if (!o || o.classList.contains('is-active')) return;
      var list = options(), i = list.indexOf(o);
      if (i > -1) setActive(i);
    });
    on(form, 'focusout', function (e) {
      var t = e.relatedTarget;
      if (t && !form.contains(t)) hide();
    });
    on(document, 'click', function (e) {
      if (open && !form.contains(e.target)) hide();
    });

    return {
      destroy: function () {
        reqId++;
        if (ctrl) ctrl.abort();
      }
    };
  }

  /* ── add-to-cart notification ────────────────────────────────────────── */
  function notification(hd, note, state, raise, on) {
    var box = note.querySelector('[data-tl-note-item]');
    var ruler = hd.querySelector('.tl-hd__ruler') || hd.querySelector('.tl-hd__bar');
    var back = null;

    function place() {
      var top = 12;
      if (ruler) {
        var b = ruler.getBoundingClientRect().bottom;
        if (b > 0) top = Math.round(b) + 8;
      }
      note.style.setProperty('--tl-nt-top', top + 'px');
    }
    function fill(item, cart) {
      if (item && item.items && item.items.length) item = item.items[0];
      box.innerHTML = '';
      if (item && (item.product_title || item.title)) {
        var media = el('span', 'tl-hd__ntim');
        var src = item.image || (item.featured_image && item.featured_image.url) || '';
        if (src) {
          var img = el('img');
          img.src = sizedImage(src, 160);
          img.alt = '';
          img.width = 76;
          img.height = 76;
          img.loading = 'eager';
          media.appendChild(img);
        } else {
          media.innerHTML = '<svg class="tl-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3.5 8h4l1.5-2.5h6L16.5 8h4v11h-17z"/><circle cx="12" cy="13.2" r="3.3"/></svg>';
        }
        var d = el('div', 'tl-hd__ntd');
        if (item.vendor) d.appendChild(el('p', 'tl-hd__ntb', item.vendor));
        var name = el('p', 'tl-hd__ntn');
        if (item.url) {
          var link = el('a', null, item.product_title || item.title);
          link.href = item.url;
          name.appendChild(link);
        } else {
          name.textContent = item.product_title || item.title;
        }
        d.appendChild(name);
        if (!item.product_has_only_default_variant && item.variant_title) {
          d.appendChild(el('p', 'tl-hd__ntvr', item.variant_title));
        }
        var cents = item.final_price != null ? item.final_price : item.price;
        if (cents != null) {
          var price = el('p', 'tl-hd__ntp', moneyText(cents));
          if (item.quantity > 1) price.appendChild(el('span', 'tl-hd__ntq', 'Qty ' + item.quantity));
          d.appendChild(price);
        }
        box.appendChild(media);
        box.appendChild(d);
      }
      if (cart) {
        var n = String(parseInt(cart.item_count, 10) || 0);
        each(note.querySelectorAll('[data-tl-cart-count]'), function (c) { c.textContent = n; });
      }
    }
    function openNote(detail) {
      fill(detail.item, detail.cart);
      place();
      if (!state.note) {
        var a = document.activeElement;
        back = a && a !== document.body && !note.contains(a) ? a : null;
      }
      state.note = true;
      raise();
      note.hidden = false;
      void note.offsetWidth;
      note.classList.add('is-in');
      focusEl(note);
    }
    function closeNote(restore) {
      if (!state.note) return;
      state.note = false;
      note.classList.remove('is-in');
      note.hidden = true;
      raise();
      if (restore && back && document.contains(back)) focusEl(back);
      back = null;
    }

    on(document, 'tl:cart:added', function (e) {
      openNote(e.detail || {});
    });
    each(note.querySelectorAll('[data-tl-note-close]'), function (b) {
      on(b, 'click', function () { closeNote(true); });
    });
    on(document, 'keydown', function (e) {
      if (state.note && e.key === 'Escape') {
        var inside = note.contains(document.activeElement);
        closeNote(inside);
        if (inside) e.preventDefault();
      }
    });
    on(document, 'click', function (e) {
      if (state.note && !note.contains(e.target)) closeNote(false);
    });
  }

  /* ── boot ────────────────────────────────────────────────────────────── */
  var instances = typeof WeakMap === 'function' ? new WeakMap() : null;
  function start(hd) {
    var api = init(hd);
    if (instances) instances.set(hd, api);
  }
  function stop(hd) {
    var api = instances && instances.get(hd);
    if (api) api.destroy();
    if (instances) instances.delete(hd);
  }

  if (typeof TL.onSections === 'function') {
    TL.onSections(SEL, start, stop);
  } else {
    var run = function (scope) {
      each((scope || document).querySelectorAll(SEL), function (hd) {
        if (hd.dataset.tlInit) return;
        hd.dataset.tlInit = '1';
        start(hd);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
    else run();
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      each(e.target.querySelectorAll(SEL), function (hd) {
        stop(hd);
        delete hd.dataset.tlInit;
      });
    });
  }
})();
